import { Edit, Delete } from "@mui/icons-material";

import { TableActions } from "../../../components/v3";

export const getStageTableColumns = (handleActions, hasEditStage, hasDeleteStage) => {
  const headers = [
    { field: "sl", headerName: "Sl No", flex: 0.75, sortable: false },
    {
      field: "name",
      headerName: "Stage Name",
      flex: 2,
      sortable: true,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      sortable: true,
    },
  ];
  if (hasEditStage || hasDeleteStage) {
    headers.push({
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const actions = [];
        if (hasEditStage) {
          actions.push({
            icon: Edit,
            type: "edit",
            label: "Edit",
            onClick: handleActions,
          });
        }
        if (hasDeleteStage) {
          actions.push({
            icon: Delete,
            type: "delete",
            label: "Delete",
            onClick: handleActions,
          });
        }
        return <TableActions item={params} actions={actions} />;
      },
    });
  }
  return headers;
};
